import React from 'react';
import ExecutiveCommandCenterPage from '../../features/executive-command-center/pages/ExecutiveCommandCenterPage';
import { AppShell, PageContainer } from '../../features/ui-system';

const AdminExecutiveCommandCenter = () => (
  <AppShell>
      <PageContainer>
    <ExecutiveCommandCenterPage />
              </PageContainer>
    </AppShell>
);

export default AdminExecutiveCommandCenter;


